import BaseListStore from 'stores/BaseListStore';
import BoxStore, { IBox } from 'stores/box/BoxStore';
import { observable, makeObservable, runInAction } from 'mobx';
import { get, post } from 'stores/_services/dataService';

export default class BoxListStore extends BaseListStore<BoxStore> {
    targetGroupBoxIds: Record<string, string[]> = {};

    constructor() {
        super({
            itemStore: BoxStore
        });

        makeObservable(this, {
            targetGroupBoxIds: observable
        });
    }

    get allDataBox(): IBox | undefined {
        const iter = this.data.entries();

        for (const [, value] of iter) {
            if (value.box.timeWindow) {
                return value.box;
            }
        }
    }

    findBoxesByTargetGroup(targetId: string | null): IBox[] {
        const idArr = targetId ? this.targetGroupBoxIds[targetId] : this.ids;

        return idArr?.map((id) => this.data.get(id)?.box) || [];
    }

    async getBox(boxId: string): Promise<void> {
        const { data } = await get(`boxes/${boxId}`);

        this._updateData(data);
    }

    async getBoxesByTargetGroup(targetId: string | null): Promise<void> {
        const options: any = {
            filter: {
                where: { targetId },
                order: ['targetId DESC', 'createdBy DESC', 'timewindow ASC', 'name ASC']
            }
        };

        const { data } = await get('boxes', options);

        if (targetId && !this.targetGroupBoxIds[targetId]) {
            //every step that updates observables in an asynchronous process should be marked as action(one way to use is runInAction), Only synchronous changes to observable data works in actions
            runInAction(() => {
                this.targetGroupBoxIds[targetId] = [];
            });
        }

        this._updateData(data);
        this._updateIds(data, 0, targetId ? this.targetGroupBoxIds[targetId] : this.ids);
    }

    async refreshBox(boxId: string): Promise<void> {
        await post(`/boxes/${boxId}/refresh`);
    }

    getDisabledMessage(item: IBox) {
        if (item.disabled && !item.refreshDisabled) {
            return 'Data is available but needs to be refreshed';
        }

        return 'No data available';
    }
}
